import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'friendlyBoolean',
    standalone: false
})
export class FriendlyBooleanPipe implements PipeTransform {
  transform(value: Boolean): any {
    return value ? 'Yes' : 'No';
  }
}
